/**
* Zoom Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Zoom Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'zoom-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.zoom-content' ).each( function( key, val ) {
        const content = $( this ).find( '.wysiwyg' )[0];
        const height = $( this ).find( '.inner-area' ).outerHeight();
        window.scrollRefreshPriority--;

        const pinner = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            pin: $( this ).find( '.inner-area' )[0],
            start: 'top top',
            end: '=+' + height,
            pinSpacing: false,
            refreshPriority: window.scrollRefreshPriority,
            scrub: 0,
            // markers: true,
          },
        } );

        window.scrollRefreshPriority--;
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top top',
            end: '=+' + height,
            refreshPriority: window.scrollRefreshPriority,
            scrub: 0,
            // markers: true,
          },
        } );
        tl.to( content, {scale: '1', opacity: '1', ease: 'linear'}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'zoom-content', COMPONENT );
} )( app );
